import { LUX_PLUS_MONTH_CAMPAIGN_ID, LUX_PLUS_MONTH_TAKEOVER_ID, LUX_PLUS_MONTH_TAKEOVER_REGIONS } from './constants/luxPlusMonthTakeoverConstants'

const luxPlusMonthTakeoverConfig: App.SiteTakeoverConfig = {
  id: LUX_PLUS_MONTH_TAKEOVER_ID,
  regions: LUX_PLUS_MONTH_TAKEOVER_REGIONS,
  campaignTags: new Set([LUX_PLUS_MONTH_CAMPAIGN_ID]),
  verticals: new Set(['home', 'hotel', 'tours', 'cruise', 'experience']),
  offerTypes: new Set([
    'hotel',
    'cruise',
    'tour', // Tour V1
    'direct_tour', 'partner_tour', 'connection_tour', // Tour V2
    'experience',
  ]),
  // No custom background — home hero carousel background is sourced from the
  // enableSiteTakeover lab payload (backgroundRef/backgroundStyle) instead.
  backgroundElement: () => null,
  palette: 'inverse',
  // Home page hero carousel content is sourced from the enableHeroCarouselTakeover lab payload
  // instead of being hardcoded here — see HeroOfferCarouselSection.tsx.
}

export default luxPlusMonthTakeoverConfig
